import defaultStates, { defaultLifeCycle, states } from '@/constants/lifecycle';

const searchActions = {
  CLOSE_SEARCH: 'CLOSE_SEARCH',
  CLOSE_SEARCHES: 'CLOSE_SEARCHES',
  CREATE_SEARCH: 'CREATE_SEARCH',
  DECODE_SEARCH_QUERY: 'DECODE_SEARCH_QUERY',
  DELETE_SEARCH: 'DELETE_SEARCH',
  DESTROY_SEARCH: 'DESTROY_SEARCH',
  DESTROY_SEARCH_ERROR: 'DESTROY_SEARCH_ERROR',
  EDIT_SEARCH: 'EDIT_SEARCH',
  EDIT_SEARCH_ERROR: 'EDIT_SEARCH_ERROR',
  FETCH_SEARCH: 'FETCH_SEARCH',
  FETCH_SEARCH_CONFIG: 'FETCH_SEARCH_CONFIG',
  FETCH_SEARCHES: 'FETCH_SEARCHES',
  FIND: 'FIND',
  HIDE_DELETE_SEARCH: 'HIDE_DELETE_SEARCH',
  HIDE_SAVE_SEARCH: 'HIDE_SAVE_SEARCH',
  NEW_SEARCH: 'NEW_SEARCH',
  NEW_SEARCH_ERROR: 'NEW_SEARCH_ERROR',
  REFRESH_FIND: 'REFRESH_FIND',
  REFRESH_SEARCHES: 'REFRESH_SEARCHES',
  SHOW_DELETE_SEARCH: 'SHOW_DELETE_SEARCH',
  SHOW_DELETE_SEARCHES: 'SHOW_DELETE_SEARCHES',
  SHOW_FIND_ERROR: 'SHOW_FIND_ERROR',
  SHOW_FIND_RESULTS: 'SHOW_FIND_RESULTS',
  SHOW_SAVE_SEARCH: 'SHOW_SAVE_SEARCH',
  SHOW_SEARCH: 'SHOW_SEARCH',
  SHOW_SEARCH_CONFIG: 'SHOW_SEARCH_CONFIG',
  SHOW_SEARCH_CONFIG_ERROR: 'SHOW_SEARCH_CONFIG_ERROR',
  SHOW_SEARCH_ERROR: 'SHOW_SEARCH_ERROR',
  SHOW_SEARCHES: 'SHOW_SEARCHES',
  SHOW_SEARCHES_ERROR: 'SHOW_SEARCHES_ERROR',
  TOGGLE_OMNI_SEARCH_FLAGS: 'TOGGLE_OMNI_SEARCH_FLAGS',
  TOGGLE_SEARCH_SELECTED: 'TOGGLE_SEARCH_SELECTED',
  TOGGLE_SEARCHES_PRESENTATION: 'TOGGLE_SEARCHES_PRESENTATION',
  TOGGLE_SEARCHES_SELECTED: 'TOGGLE_SEARCHES_SELECTED',
  UPDATE_ACTIVE_SEARCH_PROPERTIES: 'UPDATE_ACTIVE_SEARCH_PROPERTIES',
  UPDATE_SEARCH: 'UPDATE_SEARCH',
  UPDATE_SEARCH_PROPERTIES: 'UPDATE_SEARCH_PROPERTIES',
  UPDATE_SEARCHES_FILTER: 'UPDATE_SEARCHES_FILTER',
  UPDATE_SEARCHES_FLAGS: 'UPDATE_SEARCHES_FLAGS',
};

export const searchLists = ['saved', 'ribbon'];

export const configLists = ['all'];

export const searchCategories = [...searchLists, 'open', 'deletion'];

export const searchLifeCycle = [...defaultLifeCycle, 'searchStatus', 'searchErrors', 'decodeStatus', 'decodeErrors'];

export const searchStates = {
  ...defaultStates,
  searchStatus: states.NONE,
  lastEdited: '',
  searchErrors: [],
  filtersVisible: false,
};

export const searchPermissions = {
  UPDATE: 'can_update',
  DESTROY: 'can_destroy',
  VISIBILITY: 'can_change_visibility',
  SECURITY: 'can_manage_perms',
  INVITE_MEMBER: 'can_invite_user',
  REMOVE_MEMBER: 'can_remove_user',
  AUDIT: 'can_read_audit',
};

export const searchInfoTypes = {
  VECTOR_SEARCH: 'vector_search',
};

export const facetTypes = {
  COMPLEX: 'object',
  COMPLEX_COLLECTION: 'objects',
  STRING_COLLECTION: 'strings',
  STRING: 'string',
  DATE_TIME: 'date',
  INTEGER: 'number',
  DECIMAL: 'decimal',
  BOOLEAN: 'boolean',
};

export const collectionTypes = [
  facetTypes.STRING_COLLECTION,
];

export const checkboxTypes = [
  facetTypes.STRING_COLLECTION,
  facetTypes.STRING,
  facetTypes.DATE_TIME,
  facetTypes.INTEGER,
  facetTypes.DECIMAL,
  facetTypes.DATE_TIME,
  facetTypes.COMPLEX_COLLECTION,
];

export const dropdownTypes = [
  facetTypes.STRING,
  facetTypes.STRING_COLLECTION,
  facetTypes.COMPLEX_COLLECTION,
];

export const filterConcats = {
  AND: 'and',
  OR: 'or',
};

export const valueKey = 'value';

export const rangeValueKeys = {
  FROM: 'from',
  TO: 'to',
};

export const facetCounts = 5;

export const defaultFacetRequest = {
  count: facetCounts,
  sort: 'count',
};

export default searchActions;
